module.exports = __webpack_public_path__ + "img/icon-toggle-indeterminate-check-box.26b4c43b.svg";